import React, {useCallback, useContext, useMemo, useRef} from 'react';
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import {Datatable} from "../../../../shared/components/datatable/Datatable";
import { Card } from "antd";

const StoreInfo = () => {
    const {playerData} = useContext(PlayerContext);

    const columnData = useCallback(() => {
        const objects = Object.values(playerData.playerInfo.inventoryData?.Objects || {});
        return objects.map((object, idx) => ({...object, key: idx}));
    }, [playerData.playerInfo.inventoryData?.Objects]);

    const refreshRef = useRef(null);

    const columns = useMemo(() => ([
        {
            title: '맵 ID',
            dataIndex: 'StoreMapIndex',
            key: 'StoreMapIndex',
            width: 80,
            align: 'center',
        },
        {
            title: '오브젝트 ID',
            dataIndex: 'StoreObjectIndex',
            width: 80,
            align: 'center',
        },
        {
            title: '스토어',
            dataIndex: 'StoreType',
            width: 80,
            align: 'center',
        },
        {
            title: '레벨',
            dataIndex: 'Level',
            width: 80,
            align: 'center',
        },
    ]), [playerData.playerInfo.inventoryData?.Objects]);

    return (
        <Card style={{margin: 8, padding: 8}}>
            <Datatable columns={columns} rows={columnData()} refreshRef={refreshRef} />
        </Card>
    );
};

export default StoreInfo;